import React from 'react';
import './index.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LanguageWrapper } from './components/LanguageWrapper';
import { Footer } from './components/Footer';

export const App = () => {
  return (
    <div className="min-h-screen flex flex-col" dir="auto">
      <Router>
        <Routes>
          <Route path=":lang/*" element={<LanguageWrapper />} />
          <Route path="/*" element={<LanguageWrapper />} />
        </Routes>
      </Router>
      <Footer />
    </div>
  );
}
